import { Modal } from 'antd';
import React from 'react'
import styled from 'styled-components';
import { ModalCrossIcon } from '../utils/Images';
import { useDispatch } from 'react-redux';
import { authlogout } from '../store/Authentication';

const LogoutModal = ({ openLogoutModal, handleCancelLogoutModal }) => {
    const dispatch = useDispatch()
    return (
        <Modal centered open={openLogoutModal} onOk={handleCancelLogoutModal} onCancel={handleCancelLogoutModal} footer={false}>
            <LogoutModalWrapper>
                <p>Are you sure you want to logout?</p>
                <div className='img-div'>
                    <img src={ModalCrossIcon} alt="" />
                </div>
                <div className='btn-div'>
                    <button className='yes-btn' onClick={() => dispatch(authlogout([]))}>YES</button>
                    <button className='no-btn' onClick={() => handleCancelLogoutModal()}>NO</button>
                </div>
            </LogoutModalWrapper>
        </Modal>
    )
}

export default LogoutModal;

const LogoutModalWrapper = styled.div`
    padding-bottom:30px;
    p{
        font-weight:700;
        font-size:19px;
        margin-bottom:29px;
        margin-top:10px;
        text-align:center;
    }
    .img-div{
        width:100%;
        display:flex;
        align-items:center;
        justify-content:center;
        img{
            width:135px;
            height:135px;
            margin:auto;
        }
    }
    .btn-div{
        width:100%;
        display:flex;
        gap:65px;
        justify-content:center;
        margin-top:66px;

        .yes-btn{
            color:#fff;
            font-weight:700;
            font-size:16px;
            height:48px;
            padding: 0px 49px;
            border-radius: 15px;
            background: #0DA982;
            box-shadow: 0px 10px 35px 0px #6F7EC940;
            border:none;
            cursor:pointer;
        }
        .no-btn{
            color:#fff;
            font-weight:700;
            font-size:16px;
            height:48px;
            padding: 0px 49px;
            border-radius: 15px;
            background: #D81D00;
            box-shadow: 0px 10px 35px 0px #6F7EC940;
            border:none;
            cursor:pointer;
        }
    }
`;